import { maskItem } from '@/components/DashboardCard/utils/maskItem';
import React from 'react';
import { AiFillCaretDown, AiFillCaretUp, AiOutlineLine } from 'react-icons/ai';

import { CellTypeProps } from '../../interfaces';
import { Content, Text } from './styles';

const Arrow: React.FC<CellTypeProps> = ({
  extraValue,
  backgroundColor,
  badgeBackgroundColor,
  primaryBackgroundColor,
  children,
  color,
  value,
  fontWeight,
  fontSize,
  maskValue,
  deltaReversed,
}) => {
  return (
    <Content
      style={{
        backgroundColor: primaryBackgroundColor,
        justifyContent: value === '-' || !value ? 'center' : 'space-between',
      }}
    >
      {value !== '-' &&
        backgroundColor === '#00b400' &&
        (deltaReversed ? (
          <AiFillCaretDown color="#00b400" size={18} />
        ) : (
          <AiFillCaretUp color="#00b400" size={18} />
        ))}
      {value !== '-' && backgroundColor === '#FFEF00' && (
        <AiOutlineLine color="#d5a300" size={18} />
      )}
      {value !== '-' &&
        backgroundColor === '#FF2E2E' &&
        (deltaReversed ? (
          <AiFillCaretUp color="#FF2E2E" size={18} />
        ) : (
          <AiFillCaretDown color="#FF2E2E" size={18} />
        ))}
      {value || extraValue ? (
        <Text color={color} fontWeight={fontWeight} fontSize={fontSize}>
          {maskValue ? maskItem(maskValue, value) : value}
          {children !== '-' && extraValue}
        </Text>
      ) : (
        <div style={{ width: '50px' }} />
      )}
    </Content>
  );
};
export default Arrow;
